import styles from '../NotFoundDocument/NotFoundDocument.module.sass'
import '../../styles/global.sass'
import Mantenimiento from '../../assets/ilustrations/mantenimiento.svg'

function Manteniment (props: any) { 
    return (
        <div className={styles.container} >
            <div className='container'>
                <div className={styles.title }>Lloc web en manteniment</div>
                <div className={styles.subTitle }>Estem treballant per restablir la web el més aviat possible.</div>
                <div className={styles.image}><img src={Mantenimiento} /></div>
            </div>
        </div>
    );
}

export default Manteniment